import React, {useState} from 'react';
import Style from './index.module.scss';
import {Steps} from 'antd';
import BaseInfo from './Components/BaseInfo';
import {useParams} from 'react-router-dom';
import TemplateInfo from './Components/TemplateInfo';
import LoginInfo from './Components/LoginInfo';
import DetailLayout from '../../../../Components/Layout/DetailLayout';
import CurrentTenant from '../../CurrentTenant';

const Index = () => {
    const {id} = useParams<{id: string}>();
    const [current, setCurrent] = useState(0);

    return (
        <DetailLayout>
            {id && <CurrentTenant id={id} />}
            <Steps
                current={current}
                items={[
                    {
                        title: '基础信息',
                    },
                    {
                        title: '主题选择',
                    },
                    {
                        title: '登陆相关',
                    },
                ]}
            />
            <div className={Style.main}>
                {current === 0 && (
                    <BaseInfo
                        id={id!}
                        current={current}
                        setCurrent={setCurrent}
                    />
                )}
                {current === 1 && (
                    <TemplateInfo
                        id={id!}
                        current={current}
                        setCurrent={setCurrent}
                    />
                )}
                {current === 2 && (
                    <LoginInfo
                        id={id!}
                        current={current}
                        setCurrent={setCurrent}
                    />
                )}
            </div>
        </DetailLayout>
    );
};

export default Index;
